import { Card, CardContent } from '@/components/ui';
import { useLinkedPackagesByProduct } from '@/hooks/use-packages';
import { useTranslation } from '@kgc/i18n';
import { Link } from 'react-router-dom';

interface Props {
  productId: string;
}

export function LinkedPackagesSection({ productId }: Props) {
  const { t } = useTranslation();
  const { packages, isLoading } = useLinkedPackagesByProduct(productId);

  // Don't render at all if loading or no linked packages — avoid layout noise
  if (isLoading || packages.length === 0) {
    return null;
  }

  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <h2 className="mb-3 text-lg font-semibold text-foreground">
          {t('packages.productDetail.linkedPackagesTitle')}
        </h2>
        <ul className="space-y-2">
          {packages.map(pkg => (
            <li key={pkg.id}>
              <Link
                to={`/packages/${pkg.id}`}
                className="text-primary hover:underline dark:text-primary-foreground"
              >
                {pkg.name}
              </Link>
              <span className="ml-2 text-xs text-muted-foreground">({pkg.packageCode})</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
